import { cn } from "@/lib/utils"

interface TeamNameProps {
  name: string
  hue: number | null
  isUser?: boolean
  className?: string
  children?: React.ReactNode
}

const bg = "oklch(0.2 0.008 240)"

function shadowStyle(h: number | null) {
  const base = {
    WebkitTextStroke: `0.5px ${bg}`,
    paintOrder: "stroke fill" as const,
  }
  // A team that never picked a hue gets the stroke but no colored neon shadow.
  if (h == null) return base
  return {
    ...base,
    textShadow: `-1px 1px 0 oklch(0.80 0.30 ${h} / 0.9), -2px 2px 0 oklch(0.80 0.30 ${h} / 0.5), -3px 3px 0 oklch(0.80 0.30 ${h} / 0.2)`,
  }
}

/**
 * Team name with neon shadow treatment.
 * Always-on for user's team; on-hover for other teams.
 */
export function TeamName({
  name,
  hue,
  isUser,
  className,
  children,
}: TeamNameProps) {
  if (isUser) {
    return (
      <span
        className={cn("font-display truncate", className)}
        style={shadowStyle(hue)}
      >
        {name}
        {children}
      </span>
    )
  }

  return (
    <span className={cn("font-display group/tn relative truncate", className)}>
      {name}
      {children}
      <span
        className="pointer-events-none absolute inset-0 truncate opacity-0 transition-opacity duration-150 group-hover/tn:opacity-100"
        style={shadowStyle(hue)}
        aria-hidden="true"
      >
        {name}
      </span>
    </span>
  )
}
